import { render } from "./FloatingActionBtn.vue?vue&type=template&id=c9ce7202&scoped=true"
import script from "./FloatingActionBtn.vue?vue&type=script&lang=js"
export * from "./FloatingActionBtn.vue?vue&type=script&lang=js"

import "./FloatingActionBtn.vue?vue&type=style&index=0&id=c9ce7202&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9ce7202"]])

export default __exports__